<div>
    <app-user-table-title-container [titleTranslateKey]="titleTranslateKey" />
    <app-table-filters-container>
        <ng-container content-buttons>
            <app-button-add-existing-user [disabled]="!customerSpaceId || !isCustomerSpaceActive"
                (clicked)="addEmployeeClicked.emit()" />
            <app-button-create-external-user *appShowAuthorize="'USERS_WRITE'" [customerSpaceId]="customerSpaceId"
                [showPermissions]="true" [disabled]="!customerSpaceId || !isCustomerSpaceActive" />
        </ng-container>
        <ng-container content-filters>
            <app-user-is-external-dropdown subscriptSizing="dynamic" appearance="outline"
                (selectionChange)="onUserTypeChange($event)" [value]="selectedUserType" />
            <app-search-input subscriptSizing="dynamic" appearance="outline" (keyupp)="onSearchChange($event)" />
        </ng-container>
    </app-table-filters-container>
    <app-table-container>
        <app-exper-table [dataSource]="customerSpaceDataSource" [initialSortActive]="initialSortActive"
            [initialSortDirection]="initialSortDirection" (matSortChange)="storeSortOptions($event)"
            (pageChanged)="storePageOptions($event)" [initialPage]="initialPage" [initialPageSize]="initialPageSize">
            <ng-container matSort>
                <app-exper-column name="name" labelT="customer-spaces.user-management.name">
                    <ng-template let-row>
                        <app-display-user-info [userName]="row.userName"></app-display-user-info>
                    </ng-template>
                </app-exper-column>
                <app-exper-column name="account" labelT="admin.user-management.account">
                    <ng-template let-row>
                        <app-display-account [account]="row.account"></app-display-account>
                    </ng-template>
                </app-exper-column>
                <app-exper-column name="applications" labelT="customer-spaces.user-management.app-permissions.title">
                    <ng-template let-row>
                        <app-display-applications [applications]="row.applications"></app-display-applications>
                    </ng-template>
                </app-exper-column>
                <app-exper-column name="organization" labelT="admin.user-management.organization-unit">
                    <ng-template let-row>{{ row.organizationUnit }}</ng-template>
                </app-exper-column>
                <app-exper-column name="actions" label="" [noSort]="true">
                    <ng-template let-row>
                        <app-button-delete *ngIf="this.isCustomerSpaceActive && !row.userName.isDeputy"
                            (click)="deleteEmployeeInternal(row)"></app-button-delete>
                        <app-button-edit *ngIf="this.isCustomerSpaceActive && !row.userName.isDeputy"
                            (click)="openEditEmployeeDialogInternal(row)"></app-button-edit>
                        <span class="spacer" *ngIf="!this.isCustomerSpaceActive || row.userName.isDeputy"></span>
                    </ng-template>
                </app-exper-column>

            </ng-container>
        </app-exper-table>
    </app-table-container>
</div>